import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Paper,
  TablePagination,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BlockIcon from "@mui/icons-material/Block";
import { disableTopic } from "../../../services/adminServices/ModuleServices";
import { toast } from "react-toastify";
import LevelModal from "./LevelModal";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#7e7e7e",
    color: theme.palette.common.white,
    textTransform: "capitalize",
    fontSize: 16,
    fontWeight: 600
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textTransform: "capitalize",

  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd),&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.hover,
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const MakerModuleTable = ({ rows, onEditClick, getAllTopics }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [openModal, setOpenModal] = useState(false);
  const [rowData, setRowData] = useState();

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleLevelClick = (row, level) => {
    const content = {
      topicId: row.topicDetails?.topicID,
      moduleId: row.moduleDetails?.moduleID,
      level: level
    }
    setRowData(content);
    handleOpenModal();
  };

  const paginatedRows = rows?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const onDisableClick = async (row) => {
    try {
      const response = await disableTopic(row.topicDetails?.topicID, row.moduleDetails?.moduleID);
      toast.success(response.data.message);
      getAllTopics();
    } catch (error) {
      toast.error(error?.response?.data.message || error?.message || error?.error);
    }
  };

  return (
    <TableContainer component={Paper} className="table-container" sx={{ width: "100%", overflowX: "auto" }}>
      <Table sx={{ tableLayout: "auto", width: "max-content", minWidth:"100%" }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Module</StyledTableCell>
            <StyledTableCell>Topic</StyledTableCell>
            <StyledTableCell>Level 1</StyledTableCell>
            <StyledTableCell>Level 2</StyledTableCell>
            <StyledTableCell>Level 3</StyledTableCell>
            <StyledTableCell>Actions</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {paginatedRows?.map((row, index) => (
            <StyledTableRow key={index}>
              <StyledTableCell>{row.moduleDetails?.module_Name || "-"}</StyledTableCell>
              <StyledTableCell>{row?.topicDetails.topic_Name || "-"}</StyledTableCell>
              <StyledTableCell>
                {row?.practiceCounts ? (
                  <span
                    onClick={() => handleLevelClick(row, "level1")}
                    style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                  >
                    {row?.practiceCounts.level1}
                  </span>
                ) : (
                  "-"
                )}
                <Tooltip title="View Level 1 Questions">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(row.topicDetails?.level1_practicePdf, "_blank");
                    }}
                  >
                    <VisibilityIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </StyledTableCell>
              <StyledTableCell>
                {row?.practiceCounts ? (
                  <span
                    onClick={() => handleLevelClick(row, "level2")}
                    style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                  >
                    {row?.practiceCounts.level2}
                  </span>
                ) : (
                  "-"
                )}
                <Tooltip title="View Level 2 Questions">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(row.topicDetails?.level2_practicePdf, "_blank");
                    }}
                  >
                    <VisibilityIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </StyledTableCell>
              <StyledTableCell>
                {row?.practiceCounts ? (
                  <span
                    onClick={() => handleLevelClick(row, "level3")}
                    style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                  >
                    {row?.practiceCounts.level3}
                  </span>
                ) : (
                  "-"
                )}
                <Tooltip title="View Level 3 Questions">
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(row.topicDetails?.level3_practicePdf, "_blank");
                    }}
                  >
                    <VisibilityIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </StyledTableCell>
              <StyledTableCell>
                <Tooltip title="Edit">
                  <IconButton size="small" onClick={() => onEditClick(row)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Disable">
                  <IconButton size="small" onClick={() => onDisableClick(row)}>
                    <BlockIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                {/* <Tooltip title="View">
                  <IconButton size="small">
                    <VisibilityIcon fontSize="small" />
                  </IconButton>
                </Tooltip> */}
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10,20,30,60,100]}
        component="div"
        count={rows?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <LevelModal
        open={openModal}
        onClose={handleCloseModal}
        rowData={rowData}
        getAllTopics={getAllTopics}
      />
    </TableContainer>
  );
};

export default MakerModuleTable;
